import axios from "axios";
import { getToken, logoutFn } from "./authUtils";

// "eyJraWQiOiJ4TkFtTnV6aWcxaWRyMFA0cUV4MEVWT25rTHBlSnRVQ0FvczJlSFc5OFY4PSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI0ZDE3YWI0Zi0xZDYyLTRlZmMtYjUyMi1jZDQ5NTgzNzQyZGIiLCJjb2duaXRvOmdyb3VwcyI6WyJhZG1pbiJdLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtd2VzdC0yLmFtYXpvbmF3cy5jb21cL3VzLXdlc3QtMl9xUWFTcDJhVVEiLCJjbGllbnRfaWQiOiI3ZjlqNGluZjl0YTAzbzloMDFmYnM0dmNraCIsIm9yaWdpbl9qdGkiOiI4MTc2MThhMy1kY2M5LTQxNzEtYTU5Zi1mNWU0YzQ3NjEwMzYiLCJldmVudF9pZCI6ImQyNmQyMzExLTJmODEtNGFhNy04YjQ5LTFmNjU4ZWVjOTZiYSIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE3MDg2NTIyODAsImV4cCI6MTcwODczODY4MCwiaWF0IjoxNzA4NjUyMjgwLCJqdGkiOiI3OGVmY2YzYS0xNWMyLTQwZjYtODEzMC0zNmJiYzAxYTFkZGQiLCJ1c2VybmFtZSI6ImNlbGVzdGUtc2hhbyJ9.e58JdOa0HIio6JWP0M9gRQw1UUkBe0tQkBbyNM3IqiBM4-afEZi-FY6h_Te4gdFJSyrJBCsdGPFFiOwHFxs28H9t3f0H6JWtbog1aUWBcDGy6ALxmwx7DYbF_n3-Xfiu9frA5AnHZM1jpUJkuLtk0d5ZNg0z0gX4MBYpFk7hzKM56kMlAbuBNOeN-yFazAm1rnNes2b0OZSLDlASRU2QN-EcJnJWiWMm2Xmk49c1CDaEVHBcqtiC7id14vXLHgNYcSJMH9K2fcsS2OXU0QfCuYWrKvETMBQ1saR9JTqUfUo0rj9QvRaRfo_q5N6Rv4Zm3awiIa-eZycEDh-eIFoT_w";

// login success url
// https://test.guest.vision/#id_token=eyJraWQiOiI4Rk0rbTFVWCtpWFJFK2pIMkFlZW5xSDl3ZkViNld3UDVoM2dKVkF4cHZzPSIsImFsZyI6IlJTMjU2In0.eyJhdF9oYXNoIjoiTUgtTXc2Vno2bk1zU1Y1LW1Pa2NyQSIsInN1YiI6IjRkMTdhYjRmLTFkNjItNGVmYy1iNTIyLWNkNDk1ODM3NDJkYiIsImNvZ25pdG86Z3JvdXBzIjpbImFkbWluIl0sImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtd2VzdC0yLmFtYXpvbmF3cy5jb21cL3VzLXdlc3QtMl9xUWFTcDJhVVEiLCJjb2duaXRvOnVzZXJuYW1lIjoiY2VsZXN0ZS1zaGFvIiwiYXVkIjoiN2Y5ajRpbmY5dGEwM285aDAxZmJzNHZja2giLCJldmVudF9pZCI6IjQyOTViNzI0LTg5MzMtNGQ5MC05YzgxLTZhY2ExZjIzZWFjNiIsInRva2VuX3VzZSI6ImlkIiwiY3VzdG9tOmNsdWJJZCI6IlJBQzEiLCJhdXRoX3RpbWUiOjE3MDg0ODUyOTAsImV4cCI6MTcwODQ4ODg5MCwiaWF0IjoxNzA4NDg1MjkwLCJqdGkiOiIxZDU1NTI1YS0zNTViLTRhOWUtYjAwYi1hNTk2NWUxZjIzMWYiLCJlbWFpbCI6ImNlbGVzdGVAYXNjZW5kaW5nZGMuY29tIn0.XTgsMCETjdKrE1wU3Oqd_ZDOud2Ld-aTriQki4LGyTOBCPu5noSO7gtVdCjyaW-rb2aXwKFX3KS1DOR73y_Oki1cJAjShkXWnga-x1NMzn-ldgQ_SIg8-A3-xeD-1z3-036Z0PxcQC5rJRjw7-TcwhmGo2mDqfJEH5ik6w9JkDqDT2RKqkKkFMIHB4exj9n9fWlJmo95GP-lCAjyDFZwVgHPBd6IwZjPSCUdeKnGZjghonjGhTJ6PVQ7sU2nLUuKqN-R1D8lDjan2HmH0lvDXjzFlaNUGQXbiaZbJanS3JLYwoJEokuNZOWH-Q2FNIhpXrC04FVaeJRqw2zYk7etvQ&access_token=eyJraWQiOiJ4TkFtTnV6aWcxaWRyMFA0cUV4MEVWT25rTHBlSnRVQ0FvczJlSFc5OFY4PSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI0ZDE3YWI0Zi0xZDYyLTRlZmMtYjUyMi1jZDQ5NTgzNzQyZGIiLCJjb2duaXRvOmdyb3VwcyI6WyJhZG1pbiJdLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtd2VzdC0yLmFtYXpvbmF3cy5jb21cL3VzLXdlc3QtMl9xUWFTcDJhVVEiLCJ2ZXJzaW9uIjoyLCJjbGllbnRfaWQiOiI3ZjlqNGluZjl0YTAzbzloMDFmYnM0dmNraCIsImV2ZW50X2lkIjoiNDI5NWI3MjQtODkzMy00ZDkwLTljODEtNmFjYTFmMjNlYWM2IiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiBvcGVuaWQiLCJhdXRoX3RpbWUiOjE3MDg0ODUyOTAsImV4cCI6MTcwODQ4ODg5MCwiaWF0IjoxNzA4NDg1MjkwLCJqdGkiOiJiYjRmZDAwOS05NTc5LTQwN2EtODM2MC1jNmU3NGFmY2Q1YTgiLCJ1c2VybmFtZSI6ImNlbGVzdGUtc2hhbyJ9.rha6FK9b3KLaHCZhup7DQyg84DjkAYEbUcPt90QGJwy1dWpWq6R4qxEEn-ecYHE5MXAWL0IAfHWkqplp-5_9P3L-SbEpl1RZvAav2kJw7PDGaLK3DA3PxvVMtmvL_qgHMDR2_SgW2Dvqzmurrml3QPOWv_r5z7NpmLMze7cu4M2-ZXMIgSHec-IERxevL5v8QGliviCVioBk-71yE4GBNkZysWeA2MyVeZLlet-JMUGFq3tn9nQJkC9cWYxvFxufCwVsImhIPr4UBpLimxKOommky1QaWXA8wfltzaQ33LWWmnrb0Aaoi0ghoGjjRUGVc26Xh2ePTapv4vz0mi2Uhg&expires_in=3600&token_type=Bearer

export const baseURL =
  window.location.host === "test.guest.vision"
    ? "https://test.guest.vision/api"
    : "https://app.guest.vision/api";
// export const baseURL = "http://localhost:8888/api";

// 创建一个axios实例
const http = axios.create({
  baseURL: baseURL, // 设置默认的baseURL
  timeout: 500000, // 设置超时时间
  headers: {
    "Content-Type": "application/json", // 设置默认的Content-Type
  },
});

// 添加请求拦截器
http.interceptors.request.use(
  function (config) {
    const token = getToken();
    // 在发送请求之前做些什么
    // 可以在这里设置一些通用的请求头参数等
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
http.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    return response.data;
  },
  function (error) {
    console.log("http error==>>", error);
    if (error && error.response && error.response.status == 401) {
      logoutFn();
    }
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default http;
